import React from 'react';
import Button from '../../Button';

const ProductActionButtons = ({ 
    product,
    saving,
    publishing,
    onDelete,
    onSave,
    onPublish
}) => {
    return (
        <div className="bg-white rounded-lg p-6 shadow-lg max-w-7xl mx-auto mt-6">
            <div className="flex justify-center gap-4">
                <Button
                    onClick={onDelete}
                    variant="danger"
                    size="md"
                >
                    삭제
                </Button>
                <Button
                    onClick={onSave}
                    disabled={saving}
                    variant="basicNavy"
                    size="md"
                >
                    {saving ? '저장 중...' : '저장'}
                </Button>
                <Button
                    onClick={onPublish}
                    variant={product.published_to_shopify ? "secondary" : "success"}
                    size="md"
                    disabled={product.published_to_shopify || publishing}
                >
                    {publishing ? '게시 중...' : (product.published_to_shopify ? '게시됨' : '게시')}
                </Button>
            </div>
        </div>
    );
};

export default ProductActionButtons;
